import {isNotNil} from 'ramda';

import {type GetBusinessCaseOnlineOfferApiArg} from '../api/types/onlineOfferTypes';
import {queryParams} from '../consts/queryParams';

export const getOnlineOfferDataSearch = (
  queryArg: Pick<GetBusinessCaseOnlineOfferApiArg, 'openedBy' | 'sessionId'>
) => {
  const params = new URLSearchParams();
  if (isNotNil(queryArg.openedBy)) {
    params.set(queryParams.OPENED_BY, queryArg.openedBy);
  }
  if (isNotNil(queryArg.sessionId)) {
    params.set(queryParams.SESSION_ID, queryArg.sessionId);
  }

  return params.toString();
};
